/**
 * product-form.js
 * Handles: variant selection, preorder, customisation (deboss/laser),
 * color translations, image filtering, size finder, notify-me.
 *
 * Expects window.__PRODUCT_DATA__ to be set before this script runs.
 */
(function ($) {
  'use strict';

  $(document).ready(function () {

    /* ================================================================
     * 1. INITIALIZATION
     * ================================================================ */
    // pc_customizer.js (245KB, third-party) defines these globals. If it fails
    // to load (CDN hiccup, slow network, hard refresh), we must not crash
    // the entire ready callback — that would prevent swatch handlers from
    // registering and break all image filtering.
    if (typeof initliazeCustomizer === 'function') {
      initliazeCustomizer(window.jQuery);
    }
    if (typeof loadScript === 'function') {
      loadScript('plugins.min.js');
      loadScript('spectrum.js');
    }

    if (window.location.pathname.includes('/en-us') || window.location.pathname.includes('/es-us')) {
      var dutiesEl = document.querySelector('.duties-us');
      if (dutiesEl) {
        dutiesEl.style.cssText = 'display:table;background-color:#1755aa;color:white;padding:2px 6px;font-size:12px;';
      }
    }

    // Margin fix for Klaviyo teaser on mobile
    if ($(window).width() < 1001) {
      var klObserver = new MutationObserver(function () {
        if ($('.kl-teaser-VWFyyx').length > 0) {
          klObserver.disconnect();
          setTimeout(function () {
            $('.product-images.thumbnails-placement-below').css('margin-top', '50px');
          }, 1400);
        }
      });
      klObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { klObserver.disconnect(); }, 10000);
    }

    /* ================================================================
     * 2. PRODUCT DATA & STATE
     * ================================================================ */
    var DATA = window.__PRODUCT_DATA__ || {};
    var productVariants = DATA.variants || [];
    var productTags = DATA.tags || [];
    var isCurrentVariantPreorder = DATA.currentVariantPreorder || false;
    var shipDateDefault = DATA.shipDateDefault || '';
    var variantShipDates = DATA.variantShipDates || {};
    var shipsNowInLabel = DATA.shipsNowInLabel || 'Need it sooner? Ships now in:';

    function renderAvailableColors($target, colors) {
      $target.empty();
      $target.append(document.createTextNode(shipsNowInLabel + ' '));
      var strong = document.createElement('strong');
      strong.textContent = colors;
      $target.append(strong);
    }

    var originalModalContent = $('.modal_notify .modal-body').html();

    var variantIdNotify = '';
    var algunoStock = false;
    var itemSelect = '';
    var skuSelect = '';
    var indiceSlider = -1;
    var lastVariant = '';
    var colorSelect = '';
    var cargadaVariant = false;
    var ejecutandoSwiperMobile = false;

    /* ================================================================
     * 3. CACHED DOM QUERIES
     * ================================================================ */
    var $variantSelect = $('select.custom_original_select_select[name="id"]');
    var $variantOptions = $variantSelect.find('option');
    var $radioWrappers = $('.selection-wrapper.variant .radio-wrapper');
    var $submitBtn = $('.shopify-product-form .cart-buttons button[type="submit"]');
    var $submitBtnText = $submitBtn.find('.custom_span_text_pre');
    var $cartButtons = $('.shopify-product-form .cart-buttons');
    var $productSoldOut = $('#product_sold_out');
    var $sectionItems = $('#section-items-button');
    var $preContent = $('.pre-content');
    var $preInfo = $preContent.find('.pre-info');
    var $containerNotify = $('#container_notify');
    var $productAddToCart = $('#product_addto_cart');
    var $soldoutTooltip = $('#soldout-tooltip-span');
    var $preOrderStatus = $('#pre_order_status');
    var $listProductsAvail = $('#list_products_available');
    var $listProductsAvailWrap = $listProductsAvail.parent('.div_list_products');
    var allIdVariantEl = document.getElementById('all_id_variant');

    /**
     * Update the ship date text for the current variant.
     * Uses variant-level metafield (custom.ship_date) if available,
     * otherwise falls back to the section-level setting (ships_date).
     */
    function updateShipDate(variantId) {
      var text = variantShipDates[String(variantId)] || shipDateDefault;
      if (text) {
        $preInfo.text(text);
        $preContent.css('display', 'block');
      } else {
        $preContent.css('display', 'none');
      }
    }

    /* ================================================================
     * 4. COLOR TRANSLATIONS (multi-language)
     * ================================================================ */
    var COLOR_TRANSLATIONS = Object.freeze({
      "Tan": { "es": "Tan", "fr": "Tan", "de": "Tan", "it": "Abbronzatura" },
      "Black": { "es": "Negro", "fr": "Noir", "de": "Schwarz", "it": "Nero" },
      "Deep Brown": { "es": "Marrón oscuro", "fr": "Marron profond", "de": "Dunkelbraun", "it": "Marrone scuro" },
      "Navy": { "es": "Azul", "fr": "Marine", "de": "Marineblau", "it": "marina" },
      "Grey": { "es": "Gris", "fr": "Gris", "de": "Grau", "it": "Grigio" },
      "Burgundy": { "es": "Borgoña", "fr": "Bourgogne", "de": "Burgunder", "it": "Borgogna" },
      "Stone": { "es": "Piedra", "fr": "Pierre", "de": "Stein", "it": "pietra" },
      "Grey/Tan": { "es": "Gris / Tostado", "fr": "Gris / Tan", "de": "Grau / Tan", "it": "Grey / Tan" },
      "Tan/Black": { "es": "Bronceado / negro", "fr": "Tan / Noir", "de": "Hellbraun / Schwarz", "it": "Tan / nero" },
      "Tan/Tan": { "es": "Tan / Tan", "fr": "Tan / Tan", "de": "Hellbraun/hellbraun", "it": "Abbronzatura/Abbronzatura" },
      "Tan/Grey": { "es": "Tan / Grey", "fr": "Tan / Gris", "de": "Hellbraun/Grau", "it": "Marrone chiaro/grigio" },
      "Black/Tan": { "es": "Negro / Canela", "fr": "Noir / Tan", "de": "Schwarz / Hellbraun", "it": "Nero / Tan" },
      "Black/Black": { "es": "Negro/Negro", "fr": "Noir / noir", "de": "Schwarz Schwarz", "it": "Nero / Nero" },
      "Black/Grey": { "es": "Negro / Gris", "fr": "Noir / Gris", "de": "Schwarz / Grau", "it": "Nero / Grigio" },
      "Tan/Black Felt": { "es": "Tan / fieltro negro", "fr": "Feutre beige / noir", "de": "Hellbrauner/schwarzer Filz", "it": "Feltro marrone chiaro/nero" },
      "Tan/Dark Felt": { "es": "Tan / fieltro oscuro", "fr": "Feutre beige / foncé", "de": "Hellbrauner/dunkler Filz", "it": "Feltro marrone chiaro/scuro" },
      "Tan/Light Felt": { "es": "Tan / fieltro ligero", "fr": "Feutre beige / clair", "de": "Hellbraun/leichter Filz", "it": "Feltro marrone chiaro/chiaro" },
      "Black/Black Felt": { "es": "Fieltro negro / negro", "fr": "Feutre noir / noir", "de": "Schwarz/Schwarzer Filz", "it": "Feltro nero/nero" },
      "Black/Dark Felt": { "es": "Fieltro negro / oscuro", "fr": "Feutre noir / foncé", "de": "Schwarz/dunkler Filz", "it": "Feltro nero/scuro" },
      "Navy/Light Felt": { "es": "Azul marino / fieltro ligero", "fr": "Marine / feutre clair", "de": "Marine/heller Filz", "it": "Navy/feltro chiaro" },
      "Grey Microfibre": { "es": "Microfibra Gris", "fr": "Microfibre grise", "de": "Graue Mikrofaser", "it": "Microfibra grigia" },
      "Cognac": { "es": "Coñac", "fr": "Cognac", "de": "Cognac", "it": "Cognac" },
      "Olive": { "es": "Verde Oliva", "fr": "Olive", "de": "Olive", "it": "Oliva" },
      "Mocha": { "es": "Mocha", "fr": "Mocha", "de": "Mocha", "it": "Mocha" },
      "Camel": { "es": "Camel", "fr": "Camel", "de": "Camel", "it": "Cammello" },
      "Chestnut": { "es": "Chestnut", "fr": "chataîgne", "de": "Kastanie", "it": "Castagna" },
      "Caoba": { "es": "Caoba", "fr": "Caoba", "de": "Caoba", "it": "Mogano" },
      "Amber": { "es": "Ámbar", "fr": "Ambre", "de": "Bernstein", "it": "Ambra" },
      "Army Green": { "es": "Verde militar", "fr": "Vert armée", "de": "Armeegrün", "it": "Verde militare" }
    });

    var COLOR_KEYWORDS = ["tan", "navy", "brown", "black", "mocha", "olive", "grey", "burgundy", "amber", "green", "stone", "caoba"];

    /* ================================================================
     * 5. HELPER FUNCTIONS
     * ================================================================ */
    function getColor(nombreColor, idioma) {
      if (COLOR_TRANSLATIONS.hasOwnProperty(nombreColor) && COLOR_TRANSLATIONS[nombreColor].hasOwnProperty(idioma)) {
        return COLOR_TRANSLATIONS[nombreColor][idioma].toLowerCase().trim();
      }
      return nombreColor.toLowerCase().trim();
    }

    function getColorIngles(nombreColor, idioma) {
      for (var color in COLOR_TRANSLATIONS) {
        for (var lang in COLOR_TRANSLATIONS[color]) {
          if (COLOR_TRANSLATIONS[color][lang].toLowerCase().trim() === nombreColor.toLowerCase().trim() && lang === idioma) {
            return color.toLowerCase().trim();
          }
        }
      }
      return nombreColor.toLowerCase().trim();
    }

    function obtenerIdiomaDesdeURL(url) {
      var regex = /^https?:\/\/([a-z]{2})\./i;
      var match = url.match(regex);
      return (match && match.length > 1) ? match[1] : null;
    }

    function isColorName(str) {
      var lower = str.toLowerCase();
      return COLOR_KEYWORDS.some(function (c) { return lower.includes(c); });
    }

    function buscarOptionPorTexto(selectElement, textoBusqueda) {
      if (!selectElement) return null;
      var options = selectElement.getElementsByTagName('option');
      for (var i = 0; i < options.length; i++) {
        if (options[i].textContent.trim() == textoBusqueda) {
          return options[i];
        }
      }
      return null;
    }

    /* ================================================================
     * 6. EVENT HANDLERS — Option selectors, size finder, add to cart
     * ================================================================ */
    if (window.location.href.includes('variant')) {
      $('button.default-cart-button__button[name="add"]').css('display', 'inline-block');
      $productAddToCart.css('display', 'none');
      cargadaVariant = true;
    }

    $('.custom_option_other_option').change(function () {
      $productAddToCart.css('display', 'none');
      $productSoldOut.css('display', 'none');
      $('button.default-cart-button__button[name="add"]').css('display', 'inline-block');
      $('select.custom_option_other_option').css('outline-color', '#b1b1b1');
      $('.error_choose').css('display', 'none');

      var get_val_option = $(this).val().trim();

      $(this).next().find('.single-option-selector__radio').each(function () {
        var get_radio_val = $(this).val().trim();
        if (get_val_option === get_radio_val) {
          itemSelect = get_radio_val;
          skuSelect = get_radio_val;
          $(this).click();
          changethevalues();
        }
      });
    });

    $('#button_check_size').click(function () {
      $('.div_product_find').css('display', 'none');
      $('.div_no_product_find').css('display', 'none');
      $('.div_sizes').css('display', 'block');
    });

    // Size finder: check if measurement data exists
    try {
      var dataMedidas = $('#medidas_variantes').attr('data-medidas');
      if (dataMedidas && dataMedidas.length > 0) {
        var comprobarJson = JSON.parse(dataMedidas);
        if (comprobarJson.length > 0) {
          $('.button_check_size').css('display', 'block');
        }
      }
    } catch (error) {
      console.error(error);
    }

    // Size finder: find matching variant
    $('#button_find').click(function () {
      var medidasGet = JSON.parse($('#medidas_variantes').attr('data-medidas'));

      var length = $('#length_size').val();
      var lengthParse = 0;
      var width = $('#width_size').val();
      var widthParse = 0;
      var height = $('#height_size').val();
      var heightParse = 0;

      if (length !== '') lengthParse = length.replaceAll(',', '.');
      if (width !== '') widthParse = width.replaceAll(',', '.');
      if (height !== '') heightParse = height.replaceAll(',', '.');

      var lengthSize = parseFloat(lengthParse);
      var widthSize = parseFloat(widthParse) + parseFloat(heightParse) + 0.5;
      var widthSize2 = parseFloat(lengthSize) + parseFloat(heightParse) + 0.5;
      var lengthSize2 = parseFloat(widthParse);
      var scoreSearch = lengthSize + widthSize;

      var bestTitle = '';
      var bestScore = 9999;

      $variantOptions.each(function () {
        var get_sku = $(this).data('sku');
        var get_title = $(this).data('title');

        medidasGet.forEach(function (variant) {
          if (variant.sku === get_sku) {
            if ((parseFloat(variant.ancho) >= widthSize && parseFloat(variant.alto) >= lengthSize) ||
              (parseFloat(variant.ancho) >= widthSize2 && parseFloat(variant.alto) >= lengthSize2)) {
              var score = parseFloat(variant.ancho) + parseFloat(variant.alto);
              if (score - scoreSearch < bestScore) {
                bestScore = score - scoreSearch;
                bestTitle = get_title;
              }
            }
          }
        });
      });

      var auxLimpio = bestTitle.split('/')[0];
      var tituloFinal = '';

      if (isColorName(auxLimpio)) {
        tituloFinal = bestTitle.replace(auxLimpio + '/', '');
      } else {
        var parts = bestTitle.split('/');
        if (parts.length > 1) {
          tituloFinal = bestTitle.replace(parts[1] + '/', '');
        }
      }

      tituloFinal = tituloFinal.trim();

      if (tituloFinal !== '') {
        $('.div_product_find').css('display', 'block');
        $('#title_product_find').text('You must choose: ' + tituloFinal);
        $('.div_no_product_find').css('display', 'none');
      } else {
        $('.div_no_product_find').css('display', 'block');
        $('.div_product_find').css('display', 'none');
      }

      $('.div_sizes').css('display', 'none');
    });

    $('.button_close_sizes').click(function () {
      $('.div_sizes').css('display', 'none');
    });

    // Add to cart click (for "check size first" products)
    $productAddToCart.click(function () {
      if (window.location.href.includes('variant')) {
        var originalButton = document.querySelector('#section-items-button button[type="submit"]');
        if (originalButton) {
          originalButton.click();
        }
      } else {
        $('select.custom_option_other_option').css('outline-color', '#913325');
        $('.error_choose').css('display', 'block');

        var elementShipping = document.querySelector('.product-title-first');
        if (elementShipping) {
          var rect = elementShipping.getBoundingClientRect();
          var isVisible = (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
          );
          if (!isVisible) {
            elementShipping.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }
    });

    /* ================================================================
     * 7. DEBOSS / LASER CUSTOMIZATION
     * ================================================================ */
    function addOption(text, href, fragment) {
      var newAnchor = document.createElement('a');
      newAnchor.href = href;
      newAnchor.textContent = text;
      newAnchor.onclick = function () { selectOption(this); };
      fragment.appendChild(newAnchor);
    }

    function clearOptions() {
      var dropdown = document.getElementById('myDropdown-deboss');
      if (dropdown) dropdown.innerHTML = '';
    }

    function updateDropdown(tags) {
      clearOptions();
      var dropdown = document.getElementById('myDropdown-deboss');
      if (!dropdown) return;

      var fragment = document.createDocumentFragment();
      var valorDefault = '';

      var options = [
        { tag: 'deboss_FTRC', text: 'Front - Top Right Corner', href: '#FTRC' },
        { tag: 'deboss_FBRC', text: 'Front - Bottom Right Corner', href: '#FBRC' },
        { tag: 'deboss_FTLC', text: 'Front - Top Left Corner', href: '#FTLC' },
        { tag: 'deboss_FBLC', text: 'Front - Bottom Left Corner', href: '#FBLC' },
        { tag: 'deboss_FCUL', text: 'Front - Center Under Logo', href: '#FCUL' },
        { tag: 'deboss_FTLC', text: 'Front - Flap Left Corner', href: '#FTLC' },
        { tag: 'deboss_FFRC', text: 'Front - Flap Right Corner', href: '#FFRC' },
        { tag: 'deboss_FBC', text: 'Front - Bottom Center', href: '#FBC' },
        { tag: 'deboss_FFCOL', text: 'Front - Flap Center Over Logo', href: '#FFCOL' },
        { tag: 'deboss_FCOL', text: 'Front - Center Over Logo', href: '#FCOL' },
        { tag: 'deboss_FTC', text: 'Front  - Top Center', href: '#FTC' },
        { tag: 'deboss_BTLC', text: 'Back - Top Left Corner', href: '#BTLC' },
        { tag: 'deboss_BBLC', text: 'Back - Bottom Left Corner', href: '#BBLC' },
        { tag: 'deboss_BBRC', text: 'Back - Bottom Right Corner', href: '#BBRC' },
        { tag: 'deboss_BMC', text: 'Back - Middle Center', href: '#BMC' },
        { tag: 'deboss_BBC', text: 'Back - Bottom Center', href: '#BBC' },
        { tag: 'deboss_BTC', text: 'Back - Top Center', href: '#BTC' },
        { tag: 'deboss_ILC', text: 'Inside - Left Center  ', href: '#ILC' },
        { tag: 'deboss_IRC', text: 'Inside - Right Center', href: '#IRC' },
        { tag: 'deboss_SBB', text: 'Strap buckle - Bottom  Center', href: '#SBB' }
      ];

      for (var i = 0; i < options.length; i++) {
        if (tags.includes(options[i].tag)) {
          addOption(options[i].text, options[i].href, fragment);
          if (!valorDefault) {
            valorDefault = options[i].text;
          }
        }
      }

      dropdown.appendChild(fragment);
      $('#position_deboss').val(valorDefault);

      var dropBtn = document.querySelector('.dropbtn-deboss');
      if (dropBtn) dropBtn.textContent = 'Text Placement: ' + valorDefault;
    }

    /* ================================================================
     * 8. NOTIFY ME (back-in-stock)
     * ================================================================ */
    $(document).on('click', '#button_notify_send', function () {
      var email = $('#email_notify').val().trim();
      $('.notify-error').remove();

      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        $('.msg-form').append('<p class="notify-error" style="color:#c60700;margin-top:10px;">Please enter a valid email address.</p>');
        return;
      }

      $.ajax({
        type: 'POST',
        url: 'https://harber-notify-9d98c594bb4c.herokuapp.com/api/back-in-stock',
        dataType: 'json',
        contentType: 'application/json',
        headers: { 'x-api-key': '1E2WcavXwuVdWxERgrJTalJx66Xp5ko7rv' },
        data: JSON.stringify({ email: email, variantId: variantIdNotify }),
        success: function (data) {
          if (data.success) {
            $('.modal_notify .modal-body').html(
              '<div class="text-center">' +
              '<img src="https://www.harberlondon.com/cdn/shop/files/logo-harber_240x.webp?v=1662922936" alt="Harber London" class="notify-logo">' +
              '<h3 class="notify-title">You\'re on the list!</h3>' +
              '<p class="notify-text">You will be notified as soon as the next pieces are ready to ship.</p>' +
              '<button class="btn notify-btn" id="button_notify_close">KEEP BROWSING</button>' +
              '</div>'
            );
            $('#button_notify_close').click(function () {
              $('#modal_notify').modal('hide');
            });
          } else {
            $('.msg-form').append('<p class="notify-error" style="color:#c60700;margin-top:10px;">Something went wrong. Please try again later.</p>');
          }
        },
        error: function () {
          $('.msg-form').append('<p class="notify-error" style="color:#c60700;margin-top:10px;">Something went wrong. Please try again later.</p>');
        }
      });
    });

    $('#button_notify').click(function () {
      $('.modal_notify .modal-body').html(originalModalContent);
      $('#modal_notify').css('display', 'block');
      $('#modal_notify').modal('show');
    });

    /* ================================================================
     * 9. CUSTOMIZER TRIGGER
     * ================================================================ */
    $('#pc_popup_trigger').click(function () {
      if (skuSelect === '' && !cargadaVariant && !window.location.href.includes('variant')) {
        // Fallback: check if a variant is actually selected in the DOM
        var checkedRadio = document.querySelector('.radio-wrapper input[type="radio"]:checked');
        if (checkedRadio) {
          skuSelect = checkedRadio.value;
        } else {
          $('select.custom_option_other_option').css('outline-color', '#913325');
          $('.error_choose').css('display', 'block');
          return;
        }
      }

      var normalizedTags = productTags.map(function (tag) { return tag.trim().toLowerCase(); });
      var hasLaser = normalizedTags.indexOf('laser') !== -1;
      var hasDeboss = normalizedTags.some(function (tag) { return tag.indexOf('deboss') === 0; });

      if (hasLaser && hasDeboss) {
        updateDropdown(productTags);
        $('#myModalOption').css('display', 'block');
        $('#myModalOption').modal('show');
      } else if (hasDeboss) {
        updateDropdown(productTags);

        var color = $('#colorSelect').val();
        var pebbled = $('#pebbled').val();

        var imageSrcMap = {
          "https://cdn.shopify.com/s/files/1/0653/3919/files/Tan.jpg?v=1717145389": ["tan", "abbronzatura"],
          "https://cdn.shopify.com/s/files/1/0653/3919/files/Black.jpg?v=1717145389": ["black", "negro", "noir", "schwarz", "nero"],
          "https://cdn.shopify.com/s/files/1/0653/3919/files/Deep-Brown.jpg?v=1717145390": ["deep", "marrón", "marron", "dunkelbraun"],
          "https://cdn.shopify.com/s/files/1/0653/3919/files/Navy.jpg?v=1717145389": ["navy", "azul", "marine", "marineblau", "marina"],
          "https://cdn.shopify.com/s/files/1/0653/3919/files/Grey_2638a00a-acf7-4030-b1e3-4cdac26b40b4.jpg?v=1717145390": ["grey", "gris", "grau", "grigio"],
          "https://cdn.shopify.com/s/files/1/0653/3919/files/Burgundy.jpg?v=1717145390": ["burgundy", "borgoña", "bourgogne", "burgunder", "borgogna"],
          "https://cdn.shopify.com/s/files/1/0653/3919/files/Stone.jpg?v=1717145389": ["stone", "piedra", "pierre", "stein", "pietra"],
          "https://cdn.shopify.com/s/files/1/0653/3919/files/Amber-Harber-London.jpg?v=1723198331": ["amber", "ámbar", "bernstein", "ambra", "ambre"],
          "https://cdn.shopify.com/s/files/1/0653/3919/files/Army-green-Harber-London.jpg?v=1723198331": ["army", "verde", "vert", "armeegrün"]
        };

        if (pebbled && pebbled.length > 0) {
          imageSrcMap = {
            "https://cdn.shopify.com/s/files/1/0653/3919/files/Black-pebbled.jpg?v=1746696464": ["black", "negro", "noir", "schwarz", "nero"],
            "https://cdn.shopify.com/s/files/1/0653/3919/files/Brown-pebbled.jpg?v=1746696464": ["brown", "marrón", "marron", "dunkelbraun"],
            "https://cdn.shopify.com/s/files/1/0653/3919/files/Caoba-pebbled.jpg?v=1746696464": ["mahogany", "caoba", "acajou", "mahagoni", "mogano"]
          };
        }

        var colorKey = color ? color.split('-')[0] : '';
        var foundImage = null;
        var firstColor = null;

        for (var imageSrc in imageSrcMap) {
          if (imageSrcMap[imageSrc].indexOf(colorKey) !== -1) {
            foundImage = imageSrc;
            firstColor = imageSrcMap[imageSrc][0];
            break;
          }
        }

        if (color === 'grey-microfibre') {
          foundImage = 'https://cdn.shopify.com/s/files/1/0653/3919/files/Microfibre-Customise.jpg?v=1769763425';
        }

        var debossImg = document.querySelector('.image-deboss');
        if (debossImg) {
          debossImg.src = foundImage || 'https://cdn.shopify.com/s/files/1/0653/3919/files/Tan.jpg?v=1717145389';
        }

        var colorClasses = [
          "deboss-tan", "deboss-black", "deboss-deep",
          "deboss-navy", "deboss-grey", "deboss-burgundy", "deboss-stone",
          "deboss-amber", "deboss-army"
        ];

        $("#centeredText-deboss").removeClass(colorClasses.join(' '));
        if (firstColor) {
          $("#centeredText-deboss").addClass("deboss-" + firstColor);
        }

        $(".pc_customizer_text_deboss").val('');
        $("#deboss-text-select").text(' 1 to 3 characters.');
        $("#textDeboss").val('');

        $('.left-contaner').css({ 'width': '100%', 'padding': '20px', 'min-height': '760px' });
        $('.modal-dialog').css('max-width', '600px');
        $('.pc_image_fonts_wrapper').css('display', 'none');

        $('#typeCustom').val('deboss');
        $('#title-engraving').text('Deboss');
        $('#span-money').text('\u00a322.50');
        $(".deboss-text-size").text('0/3');

        $('#div-laser').css('display', 'none');
        $('#div-deboss').css('display', 'block');

        $('#myModal').css('display', 'block');
        $('#myModal').modal('show');
      } else {
        // Laser only
        $('#typeCustom').val('laser');
        $('#title-engraving').text('Laser Engraving');
        $('#span-money').text('\u00a37.50');

        $('.left-contaner').css({ 'width': '40%', 'padding': '20px 30px 20px 0', 'min-height': 'unset' });
        $('.modal-dialog').css('max-width', '1400px');
        $('.pc_image_fonts_wrapper').css('display', 'inline-block');

        $('#div-laser').css('display', 'block');
        $('#div-deboss').css('display', 'none');

        $('#myModal').css('display', 'block');
        $('#myModal').modal('show');
      }
    });

    /* ================================================================
     * 10. IMAGE SLIDER FILTERING
     * ================================================================ */
    var swiperRight = document.querySelector('.swiper-button-next');
    var swiperLeft = document.querySelector('.swiper-button-prev');

    if (swiperRight) {
      swiperRight.addEventListener('click', function () {
        indexSwiperImg++;
        if (swiperMobile && indexSwiperImg >= swiperMobile.slides.length) {
          indexSwiperImg = 0;
        }
      });
    }

    if (swiperLeft) {
      swiperLeft.addEventListener('click', function () {
        indexSwiperImg--;
        if (indexSwiperImg < 0 && swiperMobile) {
          indexSwiperImg = swiperMobile.slides.length - 1;
        }
      });
    }

    // Saved original mobile Swiper slide DOM nodes (captured on first filter call).
    // Reusing the SAME nodes avoids image re-loading — the hidden pool images
    // have loading="lazy" inside display:none, so they're never fetched by the
    // browser. The original Swiper slides ARE loaded, so reattaching them is instant.
    var _originalMobileSlides = null;

    function filtrarImagenesMovil() {
      lastMoveSwiper = 0;
      ejecutandoSwiperMobile = true;

      try {
        var swiperEl = document.querySelector('.swiper-mobile');
        var swiperWrapper = swiperEl ? swiperEl.querySelector('.swiper-wrapper') : null;
        if (!swiperWrapper) return;

        // 1. First call: capture all original slide nodes before any manipulation.
        //    destroy() removes loop clones, leaving only originals in the wrapper.
        if (!_originalMobileSlides) {
          if (swiperMobile) {
            try { swiperMobile.destroy(true, true); } catch (e) { /* */ }
            window.swiperMobile = null;
          }
          _originalMobileSlides = Array.from(swiperWrapper.children);
        } else {
          // Subsequent calls: destroy current Swiper (removes clones)
          if (swiperMobile) {
            try { swiperMobile.destroy(true, true); } catch (e) { /* */ }
            window.swiperMobile = null;
          }
        }

        // 2. Detach all slides from wrapper (nodes survive in _originalMobileSlides)
        while (swiperWrapper.firstChild) {
          swiperWrapper.removeChild(swiperWrapper.firstChild);
        }

        // 3. Re-attach matching image slides (same DOM nodes = already decoded)
        var colorCheck = colorSelect.trim().toLowerCase();
        var get_length = $radioWrappers.length;
        var hasMatch = false;

        if (get_length === 2) {
          var get_first_check = $('.radio-wrapper[data-option-index="1"] input[type="radio"]:checked').val();
          var get_second_check = $('.radio-wrapper[data-option-index="2"] input[type="radio"]:checked').val();
          var palabras = get_first_check.length > get_second_check.length ? get_first_check.split(/\s+/) : get_second_check.split(/\s+/);

          _originalMobileSlides.forEach(function (slide) {
            if (slide.querySelector('video, .video-container-swiper')) return;
            var img = slide.querySelector('img');
            var imgDataAlt = img ? (img.getAttribute('data-alt') || '') : '';
            var algunaCoincide = palabras.some(function (palabra) {
              return palabra.length > 2 && (imgDataAlt.toLowerCase().includes(palabra.toLowerCase()) && imgDataAlt.toLowerCase().includes(colorCheck));
            });
            if (algunaCoincide) {
              swiperWrapper.appendChild(slide);
              hasMatch = true;
            }
          });

          // Fallback: if multi-word match found nothing, try simple color match
          if (!hasMatch) {
            while (swiperWrapper.firstChild) {
              swiperWrapper.removeChild(swiperWrapper.firstChild);
            }
            _originalMobileSlides.forEach(function (slide) {
              if (slide.querySelector('video, .video-container-swiper')) return;
              var img = slide.querySelector('img');
              var imgDataAlt = img ? (img.getAttribute('data-alt') || '') : '';
              if (imgDataAlt.toLowerCase().includes(colorCheck)) {
                swiperWrapper.appendChild(slide);
              }
            });
          }

        } else {
          _originalMobileSlides.forEach(function (slide) {
            if (slide.querySelector('video, .video-container-swiper')) return;
            var img = slide.querySelector('img');
            var imgDataAlt = img ? (img.getAttribute('data-alt') || '') : '';
            if (imgDataAlt.toLowerCase().includes(colorCheck)) {
              swiperWrapper.appendChild(slide);
            }
          });
        }

        // 4. Append video slides at the end
        _originalMobileSlides.forEach(function (slide) {
          if (slide.querySelector('video, .video-container-swiper')) {
            swiperWrapper.appendChild(slide);
          }
        });

        // 5. Recreate Swiper (loop only when >1 slide)
        var slideCount = swiperWrapper.children.length;
        if (slideCount > 0) {
          window.swiperMobile = new Swiper(swiperEl, {
            navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
            loop: slideCount > 1,
            spaceBetween: 5
          });
          indexSwiperImg = 0;
          swiperMobile.slideToLoop(0, 0);
        }
      } catch (e) {
        // Ensure swiperMobile exists even if something fails
        if (!swiperMobile) {
          try {
            window.swiperMobile = new Swiper('.swiper-mobile', {
              navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
              loop: true,
              spaceBetween: 5
            });
          } catch (e2) { /* */ }
        }
      }
    }

    function filtrarImagenes(resetScroll) {
      var imgSwiperProducts = document.querySelectorAll('.img-swiper-product');
      var swiperImgEl = document.querySelector('.mySwiperImg');
      var get_length = $radioWrappers.length;

      var urlActual = window.location.href;
      var idioma = obtenerIdiomaDesdeURL(urlActual);

      var colorCheck = '';
      var colorSelectTrim = '';
      if (idioma !== null) {
        colorCheck = getColor(colorSelect.trim(), idioma);
        colorSelectTrim = getColorIngles(colorSelect.trim(), idioma);
      } else {
        colorCheck = colorSelect.trim().toLowerCase();
        colorSelectTrim = colorSelect.trim().toLowerCase();
      }

      if (get_length === 2) {
        var get_first_check = $('.radio-wrapper[data-option-index="1"] input[type="radio"]:checked').val();
        var get_second_check = $('.radio-wrapper[data-option-index="2"] input[type="radio"]:checked').val();
        var palabras = get_first_check.length > get_second_check.length ? get_first_check.split(/\s+/) : get_second_check.split(/\s+/);
        var imagenMostrada = false;

        imgSwiperProducts.forEach(function (img) {
          var imgAlt = img.getAttribute('alt') || '';
          var imgDataAlt = img.getAttribute('data-alt') || '';
          var algunaCoincide = palabras.some(function (palabra) {
            return palabra.length > 2 && ((imgAlt.toLowerCase().includes(palabra.toLowerCase()) && imgAlt.toLowerCase().includes(colorCheck)) ||
              (imgDataAlt.toLowerCase().includes(palabra.toLowerCase()) && imgDataAlt.toLowerCase().includes(colorSelectTrim)));
          });

          img.style.display = algunaCoincide ? 'block' : 'none';
          imagenMostrada = imagenMostrada || algunaCoincide;
        });

        if (!imagenMostrada) {
          imgSwiperProducts.forEach(function (img) {
            var imgAlt = img.getAttribute('alt') || '';
            var imgDataAlt = img.getAttribute('data-alt') || '';
            var algunaCoincide = imgAlt.toLowerCase().includes(colorCheck) || imgDataAlt.toLowerCase().includes(colorSelectTrim);
            img.style.display = algunaCoincide ? 'block' : 'none';
          });
        }
      } else {
        imgSwiperProducts.forEach(function (img) {
          var imgAlt = img.getAttribute('alt') || '';
          var imgDataAlt = img.getAttribute('data-alt') || '';
          var algunaCoincide = imgAlt.toLowerCase().includes(colorCheck) || imgDataAlt.toLowerCase().includes(colorSelectTrim);
          img.style.display = algunaCoincide ? 'block' : 'none';
        });
      }

      // On color change (resetScroll=true): scroll to top so the first
      // matching image is visible, not the video container further down.
      // On variant change (resetScroll=false/undefined): keep current scroll.
      if (swiperImgEl && resetScroll) {
        swiperImgEl.scrollTop = 0;
      }
    }

    function normalizeText(value) {
      var text = (value || '').toString().trim().toLowerCase();
      if (typeof text.normalize === 'function') {
        text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      }
      return text;
    }

    function optionClickSlider(valorRadio) {
      colorSelect = valorRadio;
      filtrarImagenes(true);
      filtrarImagenesMovil();

      var get_radio_val = valorRadio;
      var normalizedRadioValue = normalizeText(get_radio_val);
      var hasVisibleThumb = false;

      if (!normalizedRadioValue) {
        $('.product-thumb--slider .product-thumb--cell').each(function () {
          $(this).addClass('custom_active_slides');
          $(this).show();
        });
        return;
      }

      $('.product-thumb--slider .product-thumb--cell').each(function () {
        var get_image_alt = $(this).find('img').attr('alt') || '';
        var normalizedImageAlt = normalizeText(get_image_alt);

        if (normalizedImageAlt.includes(normalizedRadioValue)) {
          hasVisibleThumb = true;
          $(this).addClass('custom_active_slides');
          $(this).show();
          var count = 1;

          var flickityInstance = $('.product-image--slider').data('flickity');
          if (flickityInstance) {
            $('.product-image--slider').flickity('destroy');
          }

          $('.product-image--slider').empty();

          $(".custom---slider-content").each(function () {
            if (this.dataset.alt && this.dataset.alt.includes('video')) {
              count = 2;
              $('.product-image--slider').append($(this).html());
            }
          });

          $(".custom---slider-content").each(function () {
            if ($(this).attr('data-alt') && $(this).attr('data-alt').includes(get_image_alt)) {
              $('.product-image--slider').append($(this).html());
            }
          });
          $('.product-image--slider').flickity({ pageDots: false, wrapAround: true });

          if (indiceSlider === -1) {
            indiceSlider = count - 1;
          }

          $(".product-thumb--slider .product-thumb--cell").removeAttr('data-index');
          if (count === 2) {
            $(".showimportant").attr('data-index', '1');
          }

          $(".custom_active_slides").each(function () {
            $(this).attr('data-index', count);
            count++;
          });
        } else {
          $(this).removeClass('custom_active_slides');
          $(this).hide();
        }
      });

      // Keep slider usable when image alt labels don't exactly match swatch value.
      if (!hasVisibleThumb) {
        $('.product-thumb--slider .product-thumb--cell').each(function () {
          $(this).addClass('custom_active_slides');
          $(this).show();
        });
      }

      setTimeout(function () {
        var flickityInstance = $('.product-thumb--slider').data('flickity');
        if (flickityInstance) {
          $('.product-thumb--slider').flickity('destroy');
        }
      }, 50);
    }

    // Initialize with current color
    var spanElement = $('.single-option-radio__label--value');
    var textoEnSpan = spanElement.text();
    optionClickSlider(textoEnSpan);

    // Show play button if video exists
    $(".custom---slider-content").each(function () {
      if (this.dataset.alt && this.dataset.alt.includes('video')) {
        $('#button-play-video').css('display', 'flex');
      }
    });

    $('#button-play-video').click(function () {
      if (swiperMobile) {
        // Only search real slides (skip loop clones) so slideToLoop index is correct
        var realSlides = document.querySelectorAll('.swiper-mobile .swiper-slide:not(.swiper-slide-duplicate)');
        for (var i = 0; i < realSlides.length; i++) {
          if (realSlides[i].querySelector('video, .video-container-swiper')) {
            swiperMobile.slideToLoop(i, 300);
            break;
          }
        }
      }
    });

    $('.single-option-radio.custom_color_option .avail').click(function () {
      var flkty = $('.product-image--slider').data('flickity');
      if (flkty) indiceSlider = flkty.selectedIndex;
      optionClickSlider($(this).find('input').attr('value'));
    });

    $('body').on('click', '.product-thumb--slider .product-thumb--cell', function (e) {
      e.preventDefault();
      var get_image_index = $(this).data('index') - 1;
      indiceSlider = get_image_index;
    });

    $(document).on('click', '.card__image-container', function (e) {
      e.preventDefault();
    });

    // Variant radio change
    $('.shopify-product-form .single-option-radio input').change(function () {
      setTimeout(function () {
        if (window.location.href.includes('variant')) {
          var urlParams = new URLSearchParams(window.location.search);
          var variantId = urlParams.get('variant');

          if (variantId) {
            var matchedVariant = productVariants.find(function (v) { return String(v.id) === variantId; });
            if (matchedVariant) {
              var spanEl = document.getElementById('variant-title');
              if (spanEl) {
                spanEl.textContent = matchedVariant.title;
              }
            }
          }
        }
      }, 100);

      setTimeout(function () {
        changethevalues();
      }, 1000);
    });

    // Initial variant state
    changethevalues();

    // Apply preorder styles if current variant is preorder
    if (isCurrentVariantPreorder) {
      $submitBtnText.text('Pre-order');
      $soldoutTooltip.removeClass('soldout-tooltip');
      $submitBtn.css('background-color', 'rgb(175, 147, 99)');
      updateShipDate(DATA.currentVariantId);
    }

    /* ================================================================
     * 11. CORE VARIANT CHANGE LOGIC
     * ================================================================ */
    function changethevalues() {
      var itemSelectCombine = itemSelect;
      var coloresDisponibles = '';
      var preOrder = false;

      skuSelect = itemSelect;

      filtrarImagenes();
      if (!ejecutandoSwiperMobile) {
        filtrarImagenesMovil();
      } else {
        ejecutandoSwiperMobile = false;
      }

      var get_length = $radioWrappers.length;

      if (get_length === 2) {
        var get_first_check = $('.radio-wrapper[data-option-index="1"] input[type="radio"]:checked').val();
        var get_second_check = $('.radio-wrapper[data-option-index="2"] input[type="radio"]:checked').val();
        itemSelectCombine += ' / ' + get_second_check;
        var combine_both = get_first_check + ' / ' + get_second_check;

        coloresDisponibles = '';
        preOrder = false;

        var selectElement = document.querySelector('.custom_option_other_option');

        // Auto-select when URL has variant
        if (window.location.href.includes('variant')) {
          if (selectElement) {
            for (var i = 0; i < selectElement.options.length; i++) {
              if (selectElement.options[i].value === get_second_check) {
                selectElement.options[i].selected = true;
                break;
              }
            }
          }
          if (itemSelect === '') {
            itemSelect = get_second_check;
          }
        }

        // Initialize skuSelect from default checked options on page load
        if (skuSelect === '') {
          skuSelect = get_second_check || get_first_check || '';
        }

        if (itemSelect === get_first_check) {
          get_first_check = null;
        }
        if (itemSelect === get_second_check) {
          get_second_check = null;
        }

        $variantOptions.each(function () {
          var get_select_text = $(this).text();
          var get_qyt = $(this).data('qyt');
          var get_allow = $(this).data('policy');

          if (get_qyt > 0) algunoStock = true;

          var auxLimpio = $('.radio-wrapper[data-option-index="2"] input[type="radio"]:checked').val();
          auxLimpio = auxLimpio.replaceAll('"', '').replaceAll('/', '');

          var auxLimpio1 = $('.radio-wrapper[data-option-index="1"] input[type="radio"]:checked').val();
          auxLimpio1 = auxLimpio1.replaceAll('"', '').replaceAll('/', '');

          if (isColorName(auxLimpio)) {
            var aux = auxLimpio;
            auxLimpio = auxLimpio1;
            auxLimpio1 = aux;
          }

          var auxGetSelectLimpio = get_select_text.replaceAll('"', '').replaceAll('/', '');

          var colorAgregar = '';

          if (auxGetSelectLimpio.includes(auxLimpio) && !auxGetSelectLimpio.includes(auxLimpio1)) {
            colorAgregar = get_select_text.split('/')[0];

            if (!isColorName(colorAgregar)) {
              colorAgregar = get_select_text.split('/')[get_select_text.split('/').length - 1];
            }

            if (get_qyt > 0) {
              if (coloresDisponibles.length === 0) {
                coloresDisponibles += colorAgregar;
              } else if (!coloresDisponibles.includes(colorAgregar)) {
                coloresDisponibles += ', ' + colorAgregar;
              }
            }
          }

          var separator = ' / ';
          var startIndex = get_select_text.indexOf(separator) + separator.length;
          var desiredPart = get_select_text.substring(startIndex);
          var getSelectPart0 = get_select_text.split('/')[0].trim();
          var getSelectPart1 = desiredPart;

          // Use getAttribute instead of regex on outerHTML
          var optionBuscado = buscarOptionPorTexto(allIdVariantEl, combine_both);

          if (optionBuscado) {
            variantIdNotify = optionBuscado.getAttribute('value');
            var option2Value = optionBuscado.getAttribute('option2');
            var option1Value = optionBuscado.getAttribute('option1');

            $('#skuSelect').val(option2Value);
            $('#colorSelect').val(option1Value);
          }

          if (((getSelectPart0.trim() === itemSelect.trim() || getSelectPart1.trim() === itemSelect.trim()) && (get_select_text.includes(get_first_check) || get_select_text.includes(get_second_check))) && get_qyt <= 0 && get_allow === 'continue') {
            $productSoldOut.hide();
            $soldoutTooltip.removeClass('soldout-tooltip');
            $cartButtons.removeClass('cart-buttons__enabled ');
            $submitBtnText.text('Pre-order');
            $submitBtn.css('background-color', 'var(--color-gold)');
            $preOrderStatus.val('Pre-order');

            if (itemSelect.length > 0) {
              updateShipDate(variantIdNotify);
            }
            $sectionItems.show();
            preOrder = true;

          } else if (((getSelectPart0.trim() === itemSelect.trim() || getSelectPart1.trim() === itemSelect.trim()) && (get_select_text.includes(get_first_check) || get_select_text.includes(get_second_check))) && get_qyt > 0) {
            $productSoldOut.hide();
            $soldoutTooltip.addClass('soldout-tooltip');
            $cartButtons.addClass('cart-buttons__enabled ');
            $submitBtnText.text('Add to Cart');
            $submitBtn.css('background-color', '#455939');
            $preOrderStatus.val('');
            $preContent.css('display', 'none');
            $sectionItems.show();

          } else if (((getSelectPart0.trim() === itemSelect.trim() || getSelectPart1.trim() === itemSelect.trim()) && (get_select_text.includes(get_first_check) || get_select_text.includes(get_second_check))) && get_qyt <= 0) {
            if ((itemSelect.length > 0 && !algunoStock) || !algunoStock) {
              $productSoldOut.show();
              $sectionItems.hide();
              $soldoutTooltip.removeClass('soldout-tooltip');
            }
          }
        });

        if (preOrder) {
          $containerNotify.css('display', 'block');
          $productAddToCart.css('display', 'none');
          $('.default-cart-button__button').css('display', 'block');
        } else {
          $containerNotify.css('display', 'none');
        }

        if (preOrder && itemSelect.length > 0 && coloresDisponibles.length > 0) {
          renderAvailableColors($listProductsAvail, coloresDisponibles);
          $listProductsAvailWrap.show();
        } else {
          $listProductsAvailWrap.hide();
        }

      } else if (get_length === 1) {
        var get_first_check = $('.radio-wrapper[data-option-index="1"] input[type="radio"]:checked').val();
        var combine_both = get_first_check;

        skuSelect = get_first_check;

        // Use getAttribute instead of regex on outerHTML
        var optionBuscado = buscarOptionPorTexto(allIdVariantEl, combine_both);

        if (optionBuscado) {
          variantIdNotify = optionBuscado.getAttribute('value');
          var option2Value = optionBuscado.getAttribute('option2');
          var option1Value = optionBuscado.getAttribute('option1');

          $('#skuSelect').val(option2Value);
          $('#colorSelect').val(option1Value);
        }

        $variantOptions.each(function () {
          var get_select_text = $(this).text();
          var get_qyt = $(this).data('qyt');
          var get_allow = $(this).data('policy');

          if (get_qyt > 0) {
            if (coloresDisponibles.length === 0) {
              coloresDisponibles += get_select_text;
            } else {
              coloresDisponibles += ', ' + get_select_text;
            }
          }

          if ((get_select_text.includes(itemSelect) && get_select_text.includes(get_first_check)) && get_qyt <= 0 && get_allow === 'continue') {
            $productSoldOut.hide();
            $soldoutTooltip.removeClass('soldout-tooltip');
            $cartButtons.removeClass('cart-buttons__enabled');
            $submitBtnText.text('Pre-order');
            $submitBtn.css('background-color', 'var(--color-gold)');
            $preOrderStatus.val('Pre-order');
            updateShipDate(variantIdNotify);
            $sectionItems.show();
            preOrder = true;

          } else if ((get_select_text.includes(itemSelect) && get_select_text.includes(get_first_check)) && get_qyt > 0) {
            $productSoldOut.hide();
            $soldoutTooltip.addClass('soldout-tooltip');
            $cartButtons.addClass('cart-buttons__enabled');
            $submitBtnText.text('Add to Cart');
            $submitBtn.css('background-color', '#455939');
            $preOrderStatus.val('');
            $preContent.css('display', 'none');
            $sectionItems.show();
            preOrder = false;

          } else if ((get_select_text.includes(itemSelect) && get_select_text.includes(get_first_check)) && get_qyt <= 0) {
            $productSoldOut.show();
            $sectionItems.hide();
            $soldoutTooltip.removeClass('soldout-tooltip');
            preOrder = false;
          }

          if (preOrder && coloresDisponibles.length > 0) {
            renderAvailableColors($listProductsAvail, coloresDisponibles);
            $listProductsAvailWrap.show();
          } else {
            $listProductsAvailWrap.hide();
          }
        });
      }

      if (preOrder) {
        $('#disponibilitySelect').val(0);
        $containerNotify.css('display', 'block');
      } else {
        $('#disponibilitySelect').val(1);
        $containerNotify.css('display', 'none');
      }

      // Hardcoded slide index for specific variant titles
      if (lastVariant !== itemSelect || lastVariant === '') {
        if ('Briefcase 13" + Nomad Insert' === itemSelect) indiceSlider = 0;
        else if ('Briefcase 13" + Tech Dopp Kit Insert' === itemSelect) indiceSlider = 6;
        else if ('Briefcase 15" + Nomad Insert' === itemSelect) indiceSlider = 0;
        else if ('Briefcase 15" + Tech Dopp Kit Insert' === itemSelect) indiceSlider = 6;
        else if ('WITH FELT PADDING "M" 50 x 30 cm (19.68" x 11.81" inches)' === itemSelect) indiceSlider = 1;
        else if ('WITH MICROFIBRE "M" 50 x 30 cm (19.68" x 11.81" inches)' === itemSelect) indiceSlider = 5;
        else if ('WITH FELT PADDING "L" 80 x 32 cm (31.49" x 12.59" inches)' === itemSelect) indiceSlider = 1;
        else if ('WITH MICROFIBRE "L" 80 x 32 cm (31.49" x 12.59" inches)' === itemSelect) indiceSlider = 5;
        else if ('WITH FELT PADDING "XL" 80 x 45 cm (31.49" x 17.71" inches)' === itemSelect) indiceSlider = 1;
        else if ('WITH MICROFIBRE "XL" 80 x 45 cm (31.49" x 17.71" inches)' === itemSelect) indiceSlider = 5;
        else if ('WITH FELT PADDING - 29 X 23 CM (11.4" x 9" INCHES)' === itemSelect) indiceSlider = 0;
        else if ('WITH MICROFIBRE PADDING - 29 X 23 CM (11.4" x 9" INCHES)' === itemSelect) indiceSlider = 4;
        else if ('WITH MICROFIBRE 13" - 33.5 X 24 CM (13.1" X  9.4" INCHES)' === itemSelect) indiceSlider = 4;
        else if ('WITH FELT PADDING 13" - 33.5 X 24 CM (13.1" X  9.4" INCHES)' === itemSelect) indiceSlider = 0;
        else if ('WITH MICROFIBRE 16" - 39 X 28 CM (15.3" X 11" INCHES)' === itemSelect) indiceSlider = 4;
        else if ('WITH FELT PADDING 16" - 39 X 28 CM (15.3" X 11" INCHES)' === itemSelect) indiceSlider = 0;
        else if ('Roll Top Backpack + Tech Dopp Kit Insert' === itemSelect) indiceSlider = 3;
        else if ('Roll Top Backpack + Nomad Insert' === itemSelect) indiceSlider = 0;
        else if ('Leather Backpack + Nomad Insert' === itemSelect) indiceSlider = 1;
        else if ('Leather Backpack + Tech Dopp Kit Insert' === itemSelect) indiceSlider = 6;
        else if ('Laptop  Briefcase - 13" /14" Medium' === itemSelect) indiceSlider = 1;
        else if ('Laptop  Briefcase - 15"/16" Large' === itemSelect) indiceSlider = 5;
      }

      lastVariant = itemSelect;
    }

  });
})(jQuery);
